import { Button } from '$components'

type Subscription = {
  plan: string
  nextRenewal: string
  status: 'active' | 'inactive'
}

type CurrentSubscriptionProps = {
  data: Subscription
}

export function CurrentSubscription({ data }: CurrentSubscriptionProps) {
  return (
    <div className="mt-stack-roomy space-y-stack-roomy">
      <div className="flex justify-between items-center">
        <div>
          <div className="font-medium">{data.plan} Plan</div>
          <div className="text-body-sm text-fg-subtle">
            Next renewal on {data.nextRenewal}
          </div>
        </div>
        <span className="px-stack-tight py-stack-dense text-caption rounded-pill bg-brand-subtle text-fg-link">
          {data.status}
        </span>
      </div>

      <Button
        variant="secondary"
        className="w-full"
      >
        Change Plan
      </Button>
    </div>
  )
}
